// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","container":"Card_container__DbXh1","img":"Card_img__8Ehvv","name":"Card_name__Qjf9y","description":"Card_description__jyadU"};